export default "__VITE_ASSET__15181cf5__"